import { BookMarked, MessagesSquare, Route } from "lucide-react";
import { hasPortalCapability, type PortalCustomerProfile } from "../lib/portalAccess";

type NavEntry = { to: string; label: string; icon: typeof Route; active: boolean };
const isUnder = (pathname: string, base: string) => pathname === base || pathname.startsWith(`${base}/`);

/**
 * Portal navigation entries of the platform expansion
 * (docs/platform-expansion-20261015.md, "Portal"), filtered by capability.
 */
export function portalPlatformNavigation(me: PortalCustomerProfile | null, pathname: string, language: "tr" | "en") {
  const tr = language === "tr";
  const workflow: NavEntry[] = [];
  const knowledge: NavEntry[] = [];
  if (hasPortalCapability(me, "roadmap")) {
    workflow.push(
      { to: "/roadmap", label: tr ? "Yol Haritası" : "Roadmap", icon: Route, active: isUnder(pathname, "/roadmap") },
      { to: "/discussions", label: tr ? "Tartışmalar" : "Discussions", icon: MessagesSquare, active: isUnder(pathname, "/discussions") },
    );
  }
  if (hasPortalCapability(me, "documentation")) {
    knowledge.push({ to: "/shared", label: tr ? "Paylaşılan Dosyalar" : "Shared Documents", icon: BookMarked, active: isUnder(pathname, "/shared") });
  }
  return { workflow, knowledge };
}
